import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../components/Dialog/Dialog';
import Text from '../../components/Text/Text';
import SingleOptionList from '../../components/SingleOptionList/SingleOptionList';
import useInstallmentDecorator from './useInstallmentDecorator';
import { useDelayed } from '../../utils/hooks';

function InstallmentOptionList({
  installments,
  onClose,
  show,
  onSelect,
  currentSelectedIndex,
}: InstallmentOptionListProps) {
  const { decorateCollection } = useInstallmentDecorator();
  const { t } = useTranslation();
  const onDismissDelayed = useDelayed(onClose);
  const listItems = decorateCollection(installments).map((decoratedInstallment) => ({
    title: decoratedInstallment.name,
    'data-testid': `installment${decoratedInstallment.object.quantity.toString()}`,
    id: decoratedInstallment.object.quantity.toString(),
    left: <Text type="secondaryPure">{decoratedInstallment.interestText}</Text>,
  }));

  return (
    <Dialog onClose={onClose} title={t('installmentQuantity')} show={show}>
      <SingleOptionList
        items={listItems}
        onSelect={(index) => {
          onSelect(index);
          onDismissDelayed();
        }}
        selectedIndex={currentSelectedIndex}
      />
    </Dialog>
  );
}

export default InstallmentOptionList;
